import { __awaiter } from "tslib";
import React from 'react';
import ReactDOM from 'react-dom';
import { buildModuleProps } from 'pathfinder/rules-engine/moduleProps';
const renderNewModule = (moduleConfig) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const reactRoot = document.createElement('div');
    const rightRail = document.querySelector('.sticky-modules-wrapper');
    const variant = (_a = moduleConfig === null || moduleConfig === void 0 ? void 0 : moduleConfig.config) === null || _a === void 0 ? void 0 : _a.variant;
    const moduleProps = buildModuleProps(moduleConfig, { variant });
    if (!rightRail) {
        return null;
    }
    reactRoot.classList.add('render-new-wiki-recommendations');
    reactRoot.classList.add('rail-module');
    reactRoot.style.marginTop = '16px';
    reactRoot.style.width = '300px';
    rightRail === null || rightRail === void 0 ? void 0 : rightRail.insertAdjacentElement('beforebegin', reactRoot);
    window.dispatchEvent(new Event('NewWikiRecommendationsLoaded'));
    const Component = yield import(
    /* webpackChunkName: "NewWikiRecommendationsModule--Component" */ '../NewWikiRecommendationsModule');
    ReactDOM.render(React.createElement(Component.default, moduleProps), reactRoot);
    return reactRoot;
});
export default renderNewModule;
